<template>
  <v-select
    :options="accessibleUnits"
    :placeholder="$t('dashboard.selectUnit')"
    :disabled="disableSelect"
    v-model="displayUnit"
    @input="atInput"
  >
    <template #no-options="{ }">
      {{ $t("dashboard.noOptions") }}
    </template>
  </v-select>
</template>

<script>
export default {
  computed: {
    accessibleUnits: function () {
      let units = [];
      for (let i = 0; i < this.$store.state.usersAccessibleUnits.length; i++) {
        const orgUnitName = this.$store.state.usersAccessibleUnits[i].name;
        const orgUnitId = this.$store.state.usersAccessibleUnits[i].id;
        const orgUnitType = this.$store.state.usersAccessibleUnits[i].type;
        const unit = { label: orgUnitName, id: orgUnitId, type: orgUnitType };
        units.push(unit);
      }
      return units;
    }
  },
  mounted() {
    let displayUnitId

    if (this.$store.state.globalUnitId && typeof (this.$store.state.globalUnitId) === 'string') {
      displayUnitId = Number(this.$store.state.globalUnitId);
    } else if (this.selectedUnitId != null) {
      displayUnitId = this.selectedUnitId;
    } else {
      displayUnitId = this.$store.state.userInfo.orgMember.orgUnit.id;
    }

    this.displayUnit = this.accessibleUnits.find((unit) => unit.id == displayUnitId);
    this.$store.state.selectedUnit = this.displayUnit
  },
  props: {
    selectedUnitId: {
      type: Number
    },
    disableSelect: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayUnit: null
    }
  },
  methods: {
    atInput() {
      this.$emit('input-change', this.displayUnit);
    }
  }
}
</script>
